<template>
  <div
    v-if="options && options.length"
    v-on-clickaway="closeMenu"
    class="checklist-dropdown"
    :class="{'menu--open': !!showOptions}"
    @click="dropMenu">
    <div>
      <div
        class="checklist-dropdown__title-wrap">
        <div class="checklist-dropdown__title-wrap__title">
          {{ title }}
        </div>
      </div>
      <div
        v-if="showOptions"
        :level="8"
        class="checklist-dropdown__options mdc-elevation--z8">
        <div
          class="checklist-dropdown__options__title"
          @click.stop="closeMenu">
          <div
            class="checklist-dropdown__options__title__select-all"
            @click.stop="changeAll">
            <m-checkbox
              v-model="checkAll"
              :indeterminate="listPartiallyChecked" />
          </div>
          {{ title }}
        </div>
        <div
          v-for="(option) in checklistData"
          :key="option.value"
          class="checklist-dropdown__options__option"
          :value="option.value"
          @click="checkboxClicked">
          <m-checkbox
            v-model="option.checked" />
          <label class="checklist-dropdown__options__option__label">
            {{ option.display }}
          </label>
          <button
            class="checklist-dropdown__options__option__only"
            @click.stop="onlyClicked(option)">
            Only
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import Elevation from 'material-components-vue/dist/elevation'
import Checkbox from 'material-components-vue/dist/checkbox'
import Vue from 'vue'
Vue.use(Elevation)
Vue.use(Checkbox)

export default {
  directives: {
    onClickaway: onClickaway
  },
  props: {
    handleChoice: {
      required: true,
      type: Function
    },
    options: {
      required: true,
      type: Array
    },
    title: {
      required: true,
      type: String
    }
  },
  data () {
    const checklistData = [ ...this.options ]
    return {
      checkAll: true,
      checklistData,
      showOptions: false
    }
  },
  computed: {
    checkedItems () {
      return this.checklistData.filter((option) => {
        return option.checked === true
      }).length
    },
    listCompletelyChecked () {
      return this.checkedItems === this.checklistData.length
    },
    listCompletelyUnchecked () {
      return this.checkedItems === 0
    },
    listPartiallyChecked () {
      return this.checkedItems > 0 && this.checkedItems < this.checklistData.length
    }
  },
  watch: {
    listCompletelyChecked () {
      this.checkAll = true
    },
    listCompletelyUnchecked () {
      this.checkAll = false
    },
    options () {
      this.checklistData = [ ...this.options ]
    }
  },
  methods: {
    changeAll () {
      if (this.listCompletelyChecked) {
        this.setAllChecked(false)
      } else {
        this.setAllChecked(true)
      }
    },
    dropMenu () {
      this.showOptions = true
    },
    checkboxClicked () {
      this.handleChoice(this.checklistData)
    },
    closeMenu () {
      this.showOptions = false
    },
    onlyClicked (onlyOption) {
      const updatedChecklist = this.checklistData.map((option) => {
        if (option.value === onlyOption.value) {
          return { ...option, checked: true }
        } else {
          return { ...option, checked: false }
        }
      })
      this.handleChoice(updatedChecklist)
    },
    setAllChecked (bool) {
      this.checklistData = this.checklistData.map((option) => {
        return { ...option, checked: bool }
      })
      this.handleChoice(this.checklistData)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import 'material-components-vue/dist/elevation/styles';
  .checklist-dropdown {
    display: inline-block;
    height: 36px;
    position: relative;
    z-index: 4;

    &__title-wrap {
      height: 35px;
      line-height: 35px;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;

      &__title {
        position: relative;
        color: $black-medium-emphasis;
        margin-right: 12px;
        padding-left: 12px;
        padding-right: 20px;
        font-weight: 500;

        &::after {
          content: "";
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid $black-medium-emphasis;

          position: absolute;
          right: 0;
          top: 14px;
          transition: transform 0.2s linear;
        }
      }
    }

    &__options {
      background-color: rgb(255, 255, 255);
      position: absolute;
      border-radius: 4px;
      top: 0;

      &__title {
        height: 36px;
        display: flex;
        align-items: center;
        color: white;
        background-color: $black-pseudo;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
        box-shadow: 0px 0px 5px -3px rgba(0, 0, 0, .20), 0px 0px 10px -27px rgba(0, 0, 0, .14), 0px 0px 14px 2px rgba(0, 0, 0, .12);

        &__select-all {
          margin-left: 8px;
        }

        .material-icons {
          color: white;
          position: relative;
          bottom: 11px;
          left: -3px;
        }
      }

      &__option {
        padding: 0 12px 0 8px;
        color: $black-disabled;
        display: flex;
        align-items: center;
        height: 36px;

        &:nth-child(2){
          margin-top: 8px;
        }
        &:last-child {
          margin-bottom: 8px;
        }
        &__label {
          white-space: nowrap;
          margin: 0 24px 0 6px;
          line-height: 1;
          color: $black-pseudo;
        }
        &__only {
          visibility: hidden;
          margin-left: auto;
          border: none;
          border-radius: 4px;
          background: rgba(0, 0, 0, 0.08);
          padding: 4px 8px;

          font-size: 12px;
          line-height: 16px;
          cursor: pointer;
          color: rgba(0, 0, 0, 0.38);
          transition: color 0.1s;
        }
        &:hover .checklist-dropdown__options__option__only {
          visibility: visible;

          &:hover {
            color: rgba(0, 0, 0, 0.87);
            text-decoration: underline;
          }
        }
      }
    }
  }

/deep/ input.mdc-checkbox__native-control:enabled:checked,
/deep/ input.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
/deep/ input.mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
/deep/ input.mdc-checkbox__native-control:enabled:checked,
/deep/ input.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
/deep/ input.mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
/deep/ .mdc-checkbox::before, .mdc-checkbox::after {
  background-color: $black-pseudo;
  border-color: $black-pseudo;
  background: $black-pseudo;
  animation: none;
}
.mdc-checkbox.mdc-ripple-upgraded::before,
.mdc-checkbox.mdc-ripple-upgraded::after {
  display: none;
  animation: none;
}
/deep/ .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate) ~ .mdc-checkbox__background {
  border-color: $black-pseudo;
  animation: none;
}
/deep/ .mdc-checkbox path {
  animation: none;
  transition: all 1s;
}
.mdc-checkbox--selected {
  opacity: 1;
}
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:checked,
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:checked,
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
/deep/ .checklist-dropdown__options__title__select-all input.mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
/deep/ .checklist-dropdown__options__title__select-all .mdc-checkbox::before, .mdc-checkbox::after {
  background-color: $mdc-theme-secondary;
  border-color: $mdc-theme-secondary;
  background: $mdc-theme-secondary;
  animation: none;
}

/deep/ .checklist-dropdown__options__title__select-all .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate) ~ .mdc-checkbox__background {
  background-color: $mdc-theme-secondary;
  border-color: $mdc-theme-secondary;
  background: $mdc-theme-secondary;
}
</style>
